import React, { useState } from 'react'
import packageJson from '../../../package.json'
import validator from 'validator';
import { Link, useNavigate } from 'react-router-dom'
import '../../scss/style.scss'
import './Login.css'
import PropTypes from 'prop-types';
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CRow,
  CImage,
  CAlert,
  CFormLabel,
  CSpinner,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser, cilLowVision } from '@coreui/icons'
// import logo from '../../assets/images/ACA-Marca-RGB.ai_-1536x560.png'
// import rutaNacional from '../../assets/images/ruta-nacional4.png'
import rutaNacional from '../../assets/images/cgnbuilding.webp'
import hide from '../../assets/images/hide.png'
import view from '../../assets/images/view.png'

const logo = '/UTNTRANSP.webp';

async function senData(credentials) {
  //   return fetch(process.env.REACT_APP_URL_API+'/api/auth/login', {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json())
}

const Login = ({ setToken, setProfile }) => {

  const navigate = useNavigate(); // Hook para navegar
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const { token, setToken } = useToken();

  // const handleLogin = async (userData) => {
  //     setToken(userData); // Llama a la función setToken para guardar el token
  //   };



  const handleClick = () => {
    setIsVisible(!isVisible);
  };

  const handleSubmit = async e => {
    setIsLoading(true);
    try {
      console.log('Error al enviar los datos:');
      console.log(email);
      e.preventDefault();
      if (!email) {
        setError('Ingresá tu correo electrónico');
        setShow(true);
        return false;
      } else if (!validator.isEmail(email)) {
        setError('Ingresá un correo electrónico válido');
        setShow(true);
        return false;
      } else if (!password) {
        setError('Ingresá tu contraseña');
        setShow(true);
        return false;
      } else {
        console.log('datos:');
        const data = await senData({
          email,
          password
        });
        // console.log(data);
        if (data.error) {

          setError(data.error);
          setShow(true);
          return false;
        }
        // handleLogin(data);
        setToken(data);
        setProfile(data.name);
        navigate('/dashboard'); // Redirige a '/home'
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      setError("Error al iniciar sesión. Por favor, inténtalo de nuevo.");
      setShow(true);
    } finally {
      setIsLoading(false); // Ocultar el spinner al finalizar la carga
      navigate('/login'); // Redirige a '/home'
    }
  }

  return (
    <div className="login-page min-vh-100 d-flex align-items-center justify-content-center p-4">
      <CContainer>
        <CCard className="login-card-container mx-auto" style={{ maxWidth: '1000px', border: 'none' }}>
          <CRow className="g-0">
            {/* Form Side */}
            <CCol md={6} className="login-form-side">
              <CCardBody className="p-0">
                <div className="text-center mb-5 mt-2">
                  <CImage className="image-container-img mb-2" src={logo} height={90} alt="Logo" style={{ objectFit: 'contain', maxWidth: '100%' }} />
                </div>

                <div className="mb-4">
                  <h3 className="fw-bold text-dark mb-1">¡Bienvenido!</h3>
                  <p className="text-muted small">Inicie sesión para acceder a su plataforma.</p>
                </div>

                {show && (
                  <CAlert className="alert-acya mb-4 border-0" color="danger" dismissible={false} style={{ background: '#fff5f5', color: '#e53e3e' }}>
                    <CIcon icon={cilLowVision} className="me-2" />
                    {error}
                  </CAlert>
                )}

                <CForm onSubmit={handleSubmit}>
                  <div className="login-input-group">
                    <CFormLabel className="login-label" htmlFor="email">
                      Correo Electrónico
                    </CFormLabel>
                    <CFormInput
                      className="login-input"
                      id="email"
                      type="email"
                      placeholder="nombre@ejemplo.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isLoading}
                      required
                    />
                  </div>

                  <div className="login-input-group mb-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <CFormLabel className="login-label" htmlFor="password">
                        Contraseña
                      </CFormLabel>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <CFormInput
                        className="login-input"
                        type={isVisible ? "text" : "password"}
                        id="password"
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isLoading}
                        required
                        style={{ paddingRight: '50px' }}
                      />
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        right: '15px',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                      }}>
                        <CButton
                          onClick={handleClick}
                          className="btn-ocultar-password p-0"
                          disabled={isLoading}
                          type="button"
                        >
                          <CImage
                            src={isVisible ? hide : view}
                            style={{ width: '24px', opacity: 0.5 }}
                          />
                        </CButton>
                      </div>
                    </div>
                  </div>

                  <CButton
                    className="btn-primary-login w-100 mb-3 shadow-sm"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <CSpinner size="sm" variant="grow" className="me-2" />
                        <span>Verificando...</span>
                      </>
                    ) : (
                      'Iniciar Sesión'
                    )}
                  </CButton>

                  <div className="text-center">
                    <div className="login-tag">VERSION V{packageJson.version}</div>
                    <div className="login-version">
                      DeepGaze • © 2026
                    </div>
                  </div>
                </CForm>
              </CCardBody>
            </CCol>

            {/* Image Side */}
            <CCol md={6} className="login-image-side d-none d-md-block" style={{
              backgroundImage: `linear-gradient(rgba(60, 75, 100, 0.4), rgba(26, 34, 47, 0.8)), url(${rutaNacional})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}>
              <div className="overlay-content text-white">
                <div className="badge bg-white text-dark mb-3 px-3 py-2 rounded-pill fw-bold" style={{ fontSize: '10px' }}>ComputerVision UTN</div>
                <h2 className="fw-bold mb-2">Visión Artificial</h2>
                <p className="opacity-75 mb-0">Análisis avanzado de infraestructura vial mediante procesamiento inteligente de imágenes.</p>
                <div className="d-flex gap-2 mt-4 opacity-50">
                  <div style={{ width: '40px', height: '4px', background: 'white', borderRadius: '2px' }}></div>
                  <div style={{ width: '15px', height: '4px', background: 'rgba(255,255,255,0.4)', borderRadius: '2px' }}></div>
                  <div style={{ width: '15px', height: '4px', background: 'rgba(255,255,255,0.4)', borderRadius: '2px' }}></div>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCard>
      </CContainer>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
  setProfile: PropTypes.func.isRequired

}

export default Login

